// Import Modules
import { registerServiceWorker } from './registerServiceWorker';
import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import * as firebase from 'firebase';

import shareThis from "share-this";
import * as twitterSharer from "share-this/dist/sharers/twitter";

// Initialize Firebase
var config = {
  apiKey: "AIzaSyAWdrMuOAVIr52d2YJySIsNEy7WuqVo5c0",
  authDomain: "climate-proof-house.firebaseapp.com",
  databaseURL: "https://climate-proof-house.firebaseio.com",
  projectId: "climate-proof-house",
  storageBucket: "climate-proof-house.appspot.com",
  messagingSenderId: "99269896476"
};
firebase.initializeApp(config);

const firebaseDb = firebase.database().ref('answers');
const firebaseAuth = firebase.auth();
window.firebase = firebase.auth();

// Firebase
$(function(){
  firebase.auth().signInAnonymously() // Signs in anon
  .catch(function(error) {
    console.log(error.message);
  });

  firebaseDb.once('value', (snap) => { // Checks if user already submitted data
    if (snap.hasChild(firebaseAuth.currentUser.uid)) {
      console.log('Youve already submitted');
      $('.question--success').show();
      $('#question-form').hide();
    }
  });

});

// Elements
let $contentsBtn = $('.contents-menu--btn');
let $contentsClose = $('#contents-menu--close');
let $contentsMenu = $('.contents-menu--overlay');

// ScrollMagic
if ($( window ).width() >= 1024) {
  let controller = new ScrollMagic.Controller();

  let scene1 = new ScrollMagic.Scene({
    triggerElement: "#pinned", // point of execution
    duration: $('#content').height(), // pin element for the window height - 1
    offset:'25%',
    reverse: true // allows the effect to trigger when scrolled in the reverse direction
  })
  .setPin("#pinned") // the element we want to pin
  .addTo(controller);
}

// Contents Menu
$contentsBtn.on('click', function(){
  $contentsMenu.addClass('--is-open');
})
$('.contents-menu--overlay a')
.add($contentsClose)
.on('click', function(){
  $contentsMenu.removeClass('--is-open');
})

// ShareThis - https://github.com/MaxArt2501/share-this
const selectionShare = shareThis({
  selector: "#shareable",
  sharers: [twitterSharer]
});
selectionShare.init();

// Form submit
$('#question-form').submit(function(target){
  event.preventDefault();  
  let userAnswer = $('#question-form input:checked').attr('data-answer');    
  let user = firebase.auth().currentUser;

  // Hide's form after submit
  $('.question--success').show();
  $(this).hide();

  // Sends data to Firebase
  firebaseDb.child(user.uid).set({
    date:Date.now(),
    answer:userAnswer
  })
});

// Citations
$(function() {
  $('sup').click(function() {
     window.location = $(this).attr('cite');
  });
});

// Poll anwsers
function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
          map.set(key, [item]);
      } else {
          collection.push(item);
      }
  });
  return map;
}

const answersArray = new Array(); // Creates empty storage array

firebaseDb.once('value').then((snap) => {
  snap.forEach((childSnap) => {
    answersArray.push(childSnap.val()); // Retrieves answers from Firebase
  });  
}).then(() => {    
  let grouped = groupBy(answersArray, item => item.answer);

  function getPollPercentage(a){    
    if(grouped.get(a)) {
      // Checks if array of answers exists to stop errors
      let result = grouped.get(a).length / answersArray.length;
      return result * 100
    } else {
      return 0 // returns 0 value for bar length
    }
  }  
  
  setTimeout((function(){
    // Injects percentage value into bars
    $('#answer-yes span').animate({
      width: getPollPercentage('yes') + '%'
    });
    $('#answer-maybe span').animate({
      width: getPollPercentage('maybe') + '%'
    });
    $('#answer-no span').animate({
      width: getPollPercentage('no') + '%'
    });
  }), 500);
});






// Register Service Worker
registerServiceWorker();



